export default {
    SET_ACTION_TYPES: (state, actionTypes) => {
        state.actionTypes = actionTypes;
    },

    SET_ACTION_LOGS: (state, actionLogs) => {
        state.actionLogs = actionLogs;
    },

    SET_PAGINATION: (state, pagination) => {
        state.pagination = pagination;
    }
};
